module.exports = __webpack_public_path__ + "static/media/refund-manage@3x.ee14143c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/refund-manage@3x.png
// module id = 1961
// module chunks = 6